import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Banner fixo no topo do dashboard quando a conta está bloqueada ou com
 * subscrição expirada. Ouve o evento `tp:accountBlocked` emitido pelo
 * interceptor Axios (services/AxiosInstance.js) ou lê `window.__tpAccountBlocked`.
 *
 * Renderiza automaticamente. Não precisa de props.
 */
const AccountBlockedBanner = () => {
  const { t } = useTranslation();
  const [blocked, setBlocked] = useState(
    typeof window !== "undefined" ? window.__tpAccountBlocked || null : null
  );

  useEffect(() => {
    const handler = (e) => setBlocked(e.detail);
    window.addEventListener("tp:accountBlocked", handler);
    return () => window.removeEventListener("tp:accountBlocked", handler);
  }, []);

  if (!blocked) return null;

  const code = blocked.code;
  const msg =
    blocked.message ||
    (code === "ACCOUNT_BLOCKED"
      ? t("banner_account_blocked") ||
        "A sua conta está bloqueada. Contacte geral@tp.software para mais informações."
      : t("banner_subscription_expired") ||
        "A sua subscrição expirou. Renove para continuar a utilizar a plataforma.");

  return (
    <div
      role="alert"
      style={{
        background: "linear-gradient(90deg,#fef3c7 0%,#fde68a 100%)",
        borderBottom: "1px solid #f59e0b",
        color: "#78350f",
        padding: "10px 18px",
        display: "flex",
        gap: 14,
        alignItems: "center",
        fontSize: 14,
        fontWeight: 500,
      }}
    >
      <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: 18 }} />
      <span style={{ flex: 1 }}>{msg}</span>
      <Link
        to="/subscription"
        style={{
          background: "#92400e",
          color: "#fff",
          padding: "6px 14px",
          borderRadius: 6,
          textDecoration: "none",
          fontWeight: 700,
          fontSize: 13,
        }}
      >
        {t("renew") || "Renovar subscrição"}
      </Link>
      <a
        href="mailto:geral@tp.software"
        style={{ color: "#78350f", textDecoration: "underline", fontSize: 13 }}
      >
        geral@tp.software
      </a>
    </div>
  );
};

export default AccountBlockedBanner;
